import z from 'zod';

export const createUpdateZodSchema = z.object({
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export type CreateUpdateType = z.infer<typeof createUpdateZodSchema>;
